import "./ActivityReviewCarousel.css";

import { Dispatch, SetStateAction } from "react";

import { CheckCircleGreenIcon } from "../../../../../../assets";
import { ProjectActivitiesConstants } from "../../../../../../constants";
import { CarouselActivityReview } from "../../../../../../models/shared/carouselActivityReviewType";
import { SearchActivityReviewsResponse } from "../../../../../../service/query";
import { StatusCard } from "../../../../../../templates/DeveloperProjectCardWithTabsTemplate/components";
import { ActivityReviewCarouselButtons, ActivityReviewProgressIndicator } from "./components";

interface ActivityReviewCarouselProps {
  type?: string;
  activityReviews?: SearchActivityReviewsResponse;
  carouselActivityReviews?: CarouselActivityReview[];
  canManageActivityReview: boolean;
  refreshActivityReviews: boolean;
  setRefreshActivityReviews: Dispatch<SetStateAction<boolean>>;
}

const completeActivityMessage = (activityStatus: string): JSX.Element | undefined => {
  switch (activityStatus) {
    case ProjectActivitiesConstants.STATUS_SUBMITTED_TO_CODE:
      return (
        <div className="CompleteActivityMessage">
          <CheckCircleGreenIcon />
          <p className="body2">With Code</p>
        </div>
      );
    case ProjectActivitiesConstants.STATUS_SUBMITTED_TO_REGISTRY:
      return (
        <div className="CompleteActivityMessage">
          <CheckCircleGreenIcon />
          <p className="body2">With Registry</p>
        </div>
      );
    case ProjectActivitiesConstants.STATUS_APPROVED:
      return (
        <div className="CompleteActivityMessage">
          <CheckCircleGreenIcon />
          <p className="body2">Complete</p>
        </div>
      );
    default:
      return undefined;
  }
};

export const ActivityReviewCarousel = ({
  type,
  activityReviews,
  carouselActivityReviews,
  canManageActivityReview,
  refreshActivityReviews,
  setRefreshActivityReviews,
}: ActivityReviewCarouselProps): JSX.Element => {
  return (
    <div className="ActivityReviewCarouselWrapper">
      <div className="ActivityReviewCarousel">
        {carouselActivityReviews?.length && carouselActivityReviews[0]?.activityStatus && (
          <StatusCard status={carouselActivityReviews[0]?.activityStatus} isFixed />
        )}
        {carouselActivityReviews?.length && carouselActivityReviews?.length > 0 && (
          <div className="ActivitiesWrapper">
            <div className="Activities">
              {canManageActivityReview ? (
                carouselActivityReviews
                  .sort((a, b) => a.type.localeCompare(b.type))
                  .map((x) => <ActivityReviewProgressIndicator key={x.uuid} activityReview={x} />)
              ) : (
                <ActivityReviewProgressIndicator
                  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                  activityReview={carouselActivityReviews.find((review) => review.type === type)!}
                />
              )}
            </div>
            {completeActivityMessage(carouselActivityReviews[0].activityStatus)}
            <ActivityReviewCarouselButtons
              activityReviews={activityReviews}
              carouselActivityReviews={carouselActivityReviews}
              canManageActivityReview={canManageActivityReview}
              type={type}
              refreshActivityReviews={refreshActivityReviews}
              setRefreshActivityReviews={setRefreshActivityReviews}
            />
          </div>
        )}
      </div>
    </div>
  );
};
